// Andón público por token: la TV colgada en la cocina, SIN login (/cocina/:token).
// Mismo patrón que el reproductor de Signage: token → RPC anónima + latido.
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';
import { apiClient } from '@/lib/api/client';
import { AndonVista } from './andonVista';
import { PisoTablero } from './shared';

interface AndonResp {
  valido: boolean; pantalla?: string; estacion?: string; tablero?: PisoTablero;
}

export function AndonTv() {
  const { token = '' } = useParams();

  const { data, isLoading } = useQuery<AndonResp>({
    queryKey: ['cat-andon-tv', token],
    queryFn: async () =>
      (await apiClient.post<AndonResp>('/rpc/piso_andon', { _token: token })).data,
    refetchInterval: 15000, staleTime: 0, retry: 1,
  });

  // Latido: deja constancia de que la pantalla está viva
  useEffect(() => {
    if (!token) return;
    const latir = () => { void apiClient.post('/rpc/piso_andon_latido', { _token: token }).catch(() => {}); };
    latir();
    const i = setInterval(latir, 60000);
    return () => clearInterval(i);
  }, [token]);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#12151a] text-white">
        <Loader2 className="mr-2 h-8 w-8 animate-spin" /> Conectando con la cocina…
      </div>
    );
  }
  if (!data?.valido || !data.tablero) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-2 bg-[#12151a] text-white">
        <p className="text-2xl font-bold">Pantalla no válida</p>
        <p className="text-white/60">Verifique la dirección con el token de esta pantalla.</p>
      </div>
    );
  }
  return <AndonVista t={data.tablero} titulo={data.pantalla} />;
}
